import '@emotion/react';

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var style = {
  wrapper: process.env.NODE_ENV === "production" ? {
    name: "1hdoey6",
    styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;background:#f5f5f7;border-radius:0.375rem;height:100%"
  } : {
    name: "gqmglq-wrapper",
    styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;background:#f5f5f7;border-radius:0.375rem;height:100%;label:wrapper;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInBhcGVyLnN0eWxlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVjIiwiZmlsZSI6InBhcGVyLnN0eWxlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnXG5jb25zdCBzdHlsZSA9IHtcbiAgd3JhcHBlcjogY3NzYFxuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgIGJhY2tncm91bmQ6ICNmNWY1Zjc7XG4gICAgYm9yZGVyLXJhZGl1czogMC4zNzVyZW07XG4gICAgaGVpZ2h0OiAxMDAlO1xuICBgLFxufVxuXG5leHBvcnQgZGVmYXVsdCBzdHlsZVxuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
export { style as default };